import { useCallback, useMemo, useState, type ReactNode } from 'react'
import {
  clearMockUser,
  getMockUser,
  setMockUser,
  type MockUser,
} from '@/utils/mockAuth'
import { MockAuthContext } from './mockAuthContext'

interface MockAuthProviderProps {
  children: ReactNode
}

export function MockAuthProvider({ children }: MockAuthProviderProps) {
  const [user, setUser] = useState<MockUser | null>(() => getMockUser())

  const login = useCallback((email: string) => {
    const nextUser = { email: email.trim() }
    setMockUser(nextUser)
    setUser(nextUser)
  }, [])

  const logout = useCallback(() => {
    clearMockUser()
    setUser(null)
  }, [])

  const value = useMemo(
    () => ({
      user,
      isAuthenticated: user !== null,
      login,
      logout,
    }),
    [user, login, logout],
  )

  return (
    <MockAuthContext.Provider value={value}>{children}</MockAuthContext.Provider>
  )
}
